import { actions } from '@/modules/DemandeDevis/store/actions';
import { getters } from '@/modules/DemandeDevis/store/getters';
import { mutations } from '@/modules/DemandeDevis/store/mutations';
import { state } from '@/modules/DemandeDevis/store/state';
import { RootState } from '@/plugins/store';
import { Module } from 'vuex';
import { DemandeDevisState } from './state';

const module: Module<DemandeDevisState, RootState> = {
    namespaced: true,
    state,
    mutations,
    actions,
    getters,
};

export default module;
export type { DemandeDevisState };
